/**
 * Tela 20 — Administração (doc 09; parcial no MVP 1 conforme doc 15):
 * usuários, perfis e permissões por ação, parâmetros financeiros versionados,
 * plano de contas, centro de custo e conta bancária. Os demais cadastros
 * mestres (distribuidor, fabricante, pilar…) chegam na Fase B.
 */
import { useSessao } from '../sessao.tsx';
import { TelaUsuarios } from './Usuarios.tsx';
import { TelaPerfis } from './Perfis.tsx';
import { CHAVES_CADASTRO, TelaCadastro, TelaParametros } from './Cadastros.tsx';
import { Vazio } from '../componentes/basicos.tsx';

export const ABAS_ADMIN = [
  { rota: 'usuarios', rotulo: 'Usuários', entidade: 'usuario', grupo: 'acesso' },
  { rota: 'perfis', rotulo: 'Perfis e permissões', entidade: 'perfil', grupo: 'acesso' },
  { rota: 'parametros', rotulo: 'Parâmetros', entidade: 'parametro', grupo: 'cadastros' },
  { rota: 'plano-contas', rotulo: 'Plano de contas', entidade: 'plano_contas', grupo: 'cadastros' },
  { rota: 'centros-custo', rotulo: 'Centros de custo', entidade: 'centro_custo', grupo: 'cadastros' },
  { rota: 'contas-bancarias', rotulo: 'Contas bancárias', entidade: 'conta_bancaria', grupo: 'cadastros' },
  { rota: 'cartoes', rotulo: 'Cartões', entidade: 'cartao', grupo: 'cadastros' },
  { rota: 'pessoas-financeiras', rotulo: 'Pessoas financeiras', entidade: 'pessoa_financeira', grupo: 'cadastros' },
] as const;

export function TelaAdministracao({ sub }: { sub: string }) {
  const { pode } = useSessao();
  const visiveis = ABAS_ADMIN.filter((a) => pode('visualizar', a.entidade));
  const atual = visiveis.find((a) => a.rota === sub) ?? visiveis[0];
  if (!atual) return <Vazio>Seu perfil não tem acesso a nenhuma área da Administração.</Vazio>;
  return (
    <section>
      <div className="abas" role="tablist">
        {visiveis.map((a) => (
          <a key={a.rota} role="tab" aria-selected={a.rota === atual.rota} className={a.rota === atual.rota ? 'ativa' : ''} href={`#/administracao/${a.rota}`}>
            {a.rotulo}
          </a>
        ))}
      </div>
      {atual.rota === 'usuarios' && <TelaUsuarios />}
      {atual.rota === 'perfis' && <TelaPerfis />}
      {atual.rota === 'parametros' && <TelaParametros />}
      {CHAVES_CADASTRO.includes(atual.rota) && <TelaCadastro key={atual.rota} chave={atual.rota} />}
    </section>
  );
}
